module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "detail-panel-box"
  }, [_c('header', [_c('strong', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._t("header")], 2), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('br'), _vm._v(" "), _c('footer', [_vm._t("footer")], 2)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55bc6a92","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/panel/details-panel.vue
// module id = eA+S
// module chunks = 511